import PaymentInstructionLayout from "../layouts/PaymentInstructionLayout";
import { useState } from "react";
import { ChevronDown, ChevronUp, ExternalLink } from "lucide-react";
import METHOD_LOGO from "./MethodLogos";
import { getVendorConfig } from "../config/ewalletVendors";

const METHOD_LOGOS = METHOD_LOGO;

export default function PaymentInstructionEwallet({
  amount,
  orderId,
  merchantName,
  expired_at,
  selected_method,
  onCheckStatus,
  ewalletName,
  ewalletCode,
  ewalletUrl,
}) {
  const [activeSection, setActiveSection] = useState("app");

  const handleEwalletPayment = () => {
    if (ewalletUrl) {
      window.location.href = ewalletUrl;
    }
  };

  const ewalletConfig = getVendorConfig(ewalletCode) || getVendorConfig("EWALLET_SHOPEEPAY");

  const instructions = {
    EWALLET_SHOPEEPAY: [
      {
        id: "app",
        title: "Aplikasi Shopee",
        content: [
          "1. Klik tombol 'Bayar dengan ShopeePay' di atas",
          "2. Anda akan diarahkan ke aplikasi Shopee",
          "3. Login dengan nomor HP dan password jika diminta",
          "4. Periksa detail pembayaran (jumlah dan merchant)",
          "5. Pilih metode pembayaran:",
          "   - ShopeePay Balance (saldo)",
          "   - SPayLater (cicilan)",
          "   - SeaBank Direct Debit",
          "6. Masukkan PIN ShopeePay Anda",
          "7. Tunggu konfirmasi pembayaran berhasil",
          "8. Anda akan otomatis kembali ke halaman ini",
          "9. Status pembayaran akan diperbarui secara otomatis",
        ],
      },
      {
        id: "web",
        title: "Website ShopeePay",
        content: [
          "1. Klik tombol 'Bayar dengan ShopeePay' di atas",
          "2. Anda akan diarahkan ke website ShopeePay",
          "3. Login dengan nomor HP dan password",
          "4. Periksa detail pembayaran",
          "5. Pilih metode pembayaran yang tersedia",
          "6. Masukkan PIN ShopeePay",
          "7. Tunggu konfirmasi pembayaran berhasil",
          "8. Kembali ke halaman ini untuk melihat status",
        ],
      },
      {
        id: "tips",
        title: "Tips Pembayaran",
        content: [
          "• Pastikan saldo ShopeePay mencukupi sebelum memulai",
          "• Masa berlaku pembayaran adalah 30 menit",
          "• Simpan bukti pembayaran untuk referensi",
          "• Jika pembayaran terdebit tapi status belum berubah, tunggu 1-3 menit",
          "• Pastikan koneksi internet stabil saat melakukan pembayaran",
        ],
      },
    ],
    EWALLET_DANA: [
      {
        id: "app",
        title: "Aplikasi Dana",
        content: [
          "1. Klik tombol 'Bayar dengan Dana' di atas",
          "2. Anda akan diarahkan ke aplikasi Dana",
          "3. Login dengan nomor HP jika diminta",
          "4. Periksa detail pembayaran (jumlah dan merchant)",
          "5. Pilih metode pembayaran yang tersedia di Dana:",
          "   - Saldo Dana",
          "   - Kartu Debit/Kredit (jika tersedia)",
          "   - Metode pembayaran lainnya",
          "6. Masukkan PIN Dana 6 digit Anda",
          "7. Tunggu konfirmasi pembayaran berhasil",
          "8. Anda akan otomatis kembali ke halaman ini",
          "9. Status pembayaran akan diperbarui secara otomatis",
        ],
      },
      {
        id: "web",
        title: "Website Dana",
        content: [
          "1. Klik tombol 'Bayar dengan Dana' di atas",
          "2. Anda akan diarahkan ke website Dana",
          "3. Login dengan nomor HP dan OTP",
          "4. Periksa detail pembayaran",
          "5. Pilih metode pembayaran yang tersedia",
          "6. Masukkan PIN Dana",
          "7. Tunggu konfirmasi pembayaran berhasil",
          "8. Kembali ke halaman ini untuk melihat status",
        ],
      },
      {
        id: "tips",
        title: "Tips Pembayaran",
        content: [
          "• Pastikan saldo Dana atau metode pembayaran lain di Dana mencukupi",
          "• Masa berlaku pembayaran adalah 30 menit",
          "• Simpan bukti pembayaran untuk referensi",
          "• Jika pembayaran terdebit tapi status belum berubah, tunggu 1-3 menit",
          "• Pastikan koneksi internet stabil saat melakukan pembayaran",
          "• Jangan tutup browser/aplikasi selama proses pembayaran",
        ],
      },
    ],
    EWALLET_GOPAY: [
      {
        id: "app",
        title: "Aplikasi Gojek / GoPay",
        content: [
          "1. Klik tombol 'Bayar dengan GoPay' di atas",
          "2. Anda akan diarahkan ke aplikasi Gojek atau GoPay",
          "3. Login jika diminta",
          "4. Periksa detail pembayaran (jumlah dan merchant)",
          "5. Pilih metode pembayaran:",
          "   - Saldo GoPay",
          "   - GoPay Later (PayLater)",
          "   - GoPay Coins",
          "6. Masukkan PIN GoPay Anda",
          "7. Tunggu konfirmasi pembayaran berhasil",
          "8. Anda akan otomatis kembali ke halaman ini",
          "9. Status pembayaran akan diperbarui secara otomatis",
        ],
      },
      {
        id: "qris",
        title: "Scan QR Code",
        content: [
          "1. Jika Anda membuka di komputer/laptop, QR Code akan ditampilkan",
          "2. Buka aplikasi Gojek, GoPay, atau aplikasi e-wallet lain yang mendukung QRIS",
          "3. Pilih menu 'Bayar' atau 'Scan'",
          "4. Arahkan kamera ke QR Code yang tampil di layar",
          "5. Periksa detail pembayaran",
          "6. Masukkan PIN untuk konfirmasi",
          "7. Tunggu konfirmasi pembayaran berhasil",
          "8. Status pembayaran akan diperbarui secara otomatis",
        ],
      },
      {
        id: "tips",
        title: "Tips Pembayaran",
        content: [
          "• Pastikan saldo GoPay atau metode pembayaran lain di Gojek mencukupi",
          "• Masa berlaku pembayaran adalah 15 menit",
          "• Simpan bukti pembayaran untuk referensi",
          "• Jika pembayaran terdebit tapi status belum berubah, tunggu 1-3 menit",
          "• Pastikan koneksi internet stabil saat melakukan pembayaran",
          "• Jangan tutup browser/aplikasi selama proses pembayaran",
        ],
      },
    ],
  };

  const sections = instructions[ewalletCode] || [];

  return (
    <PaymentInstructionLayout
      amount={amount}
      orderId={orderId}
      merchantName={merchantName}
      expiredAt={expired_at}
      selectedMethod={selected_method}
      onCheckStatus={onCheckStatus}
      paymentCredential={
        <div className="mt-4 mb-8 text-center bg-orange-50 p-6 rounded-2xl border border-orange-100">
          <div className="flex flex-col items-center gap-3 mb-4">
            <img 
              src={METHOD_LOGOS[ewalletCode] || "/placeholder.svg"} 
              alt={`${ewalletName} Logo`} 
              className="h-12 w-12 object-contain" 
            />
            <h3 className="text-2xl font-bold text-gray-800">{ewalletName}</h3>
          </div>
          
          <p className="text-gray-600 text-sm mb-6 leading-relaxed">
            {ewalletConfig.description}
          </p>

          {ewalletUrl && (
            <button
              onClick={handleEwalletPayment}
              style={{ 
                backgroundColor: ewalletConfig.brandColor,
              }}
              className="w-full text-white font-bold py-4 px-6 rounded-xl flex items-center justify-center gap-3 transition-all shadow-md active:scale-[0.98] hover:opacity-90"
            >
              <ExternalLink size={20} />
              <span>{ewalletConfig.buttonText}</span>
            </button>
          )}
          
          <p className="text-gray-500 text-[11px] mt-4 italic leading-tight">
            *Anda akan otomatis dialihkan untuk menyelesaikan pembayaran
          </p>
        </div>
      }
      howToPay={
        <div className="space-y-4 mt-6">
          <div className="flex items-center gap-2 mb-2">
            <div className="h-6 w-1 bg-orange-500 rounded-full"></div>
            <h3 className="text-xl font-bold text-gray-800">Cara Pembayaran</h3>
          </div>
          
          <div className="space-y-3">
            {sections.map((section) => (
              <div key={section.id} className="border border-gray-200 rounded-xl overflow-hidden bg-white shadow-sm transition-all">
                <button 
                  className={`w-full p-4 flex items-center justify-between transition-colors ${
                    activeSection === section.id ? "bg-orange-50" : "bg-gray-50 hover:bg-gray-100"
                  }`} 
                  onClick={() => setActiveSection(activeSection === section.id ? "" : section.id)}
                >
                  <span className={`font-semibold ${activeSection === section.id ? "text-orange-700" : "text-gray-700"}`}>
                    {section.title}
                  </span>
                  {activeSection === section.id ? 
                    <ChevronUp size={20} className="text-orange-600" /> : 
                    <ChevronDown size={20} className="text-gray-400" />
                  }
                </button>
                {activeSection === section.id && (
                  <div className="p-5 bg-white border-t border-orange-100">
                    <ul className="space-y-4">
                      {section.content.map((step, index) => {
                        const isSubItem = step.trim().startsWith("-");
                        const hasManualNumber = /^\d+\./.test(step.trim());
                        const cleanText = step.replace(/^\d+\.\s*/, "").replace(/^\s*-\s*/, "").trim();
                        
                        return (
                          <li key={index} className={`flex gap-3 text-sm text-gray-700 leading-relaxed items-start ${isSubItem ? "ml-6 mt-1" : ""}`}>
                            {isSubItem ? (
                              <span className="flex-shrink-0 mt-2 w-1.5 h-1.5 rounded-full bg-gray-300"></span>
                            ) : (
                              <span className="flex-shrink-0 flex items-center justify-center w-5 h-5 rounded-full bg-orange-100 text-orange-600 text-[10px] font-bold mt-0.5">
                                {hasManualNumber ? step.trim().match(/^\d+/)[0] : index + 1}
                              </span>
                            )}
                            <span className="flex-1 font-medium text-gray-600">
                              {cleanText}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      }
    />
  );
}
